module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-to-up-0697dd1e54ff1993b2093494e447d2a8.svg";